import { createAction } from 'redux-actions';

export const SET_PRICES = 'SET_PRICES';
export const SET_PRICES_LOADING = 'SET_PRICES_LOADING';

export const setPrices = createAction<any>(SET_PRICES);
export const setPricesLoading = createAction<any>(SET_PRICES_LOADING);
